module.exports = __webpack_public_path__ + "img/safari.95d245cd.png";